#import "../fragments/product-category-fragment.graphql"

mutation ProductCategoryUpdate($input: ProductCategoryUpdateInput!) {
    productCategoryUpdate(input: $input) {
        productCategory {
            ...ProductCategoryFragment
        }
    }
}
